import { render, staticRenderFns } from "./PartnerNumbers.vue?vue&type=template&id=5b781f89&"
import script from "./PartnerNumbers.vue?vue&type=script&lang=js&"
export * from "./PartnerNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports